module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "WKheader-wrap"
  }, [_c('div', {
    staticClass: "WKheader"
  }, [_c('img', {
    staticClass: "WKheader-icon",
    attrs: {
      "src": require("../assets/img/left-white-arrow.png")
    },
    on: {
      "click": function($event) {
        return _vm.goBack()
      }
    }
  }), _vm._v("\n    " + _vm._s(_vm.title) + "\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "WKheader-placeholder"
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-a9cdcba0!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/WKheader.vue
// module id = 148
// module chunks = 10